import { render, staticRenderFns } from "./VDialogReservaqui.vue?vue&type=template&id=382f113d"
import script from "./VDialogReservaqui.vue?vue&type=script&lang=js"
export * from "./VDialogReservaqui.vue?vue&type=script&lang=js"
import style0 from "./VDialogReservaqui.vue?vue&type=style&index=0&id=382f113d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports